// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__2vNNX","slide":"Slider_slide__182BF","goLeft":"Slider_goLeft__1s3K2","goRight":"Slider_goRight__1sPh2"};